module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_3016.fdb9996e.png";